<template>
  <el-form-item :label="label">
    <el-select v-model="inputValue" :placeholder="placeholder" :multiple="multiple"
      :collapse-tags-tooltip="multiple" :collapse-tags="multiple" :max-collapse-tags="1" :clearable="clearable">
      <el-option v-for="option in options" :key="option.id" :label="option.itemName" :value="option.id"></el-option>
    </el-select>
  </el-form-item>
</template>
<script>
import { inject } from 'vue';

export default {
  kind: 'yq-多组件通用',
  props: {
    type: [String, Number], // 数据类型，如 select、input 等
    options: Array, // 当类型为 select 时的选项数据
    placeholder: String, // 输入框和日期选择器的占位文本
    value: [String, Number, Array, Date], // 绑定的值
    multiple: Boolean, // 是否支持多选
    label: String,
    clearable: Boolean,
    keyName: String,
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const reset = () => {
      // eslint-disable-next-line no-use-before-define
      inputValue.value = '';
    };
    const inputValue = useQuery('selectLists', props.value, reset);
    return {
      props,
      inputValue,
    };
  },
};
</script>
